<template>
  <div class="container">
    <!-- Content header -->
    <div class="columns">
      <div class="column is-3">
        <h3 class="title is-3">My Leads</h3>
      </div>
      <div class="column is-7 has-text-centered">
        <button
          type="button"
          class="button is-info is-outlined is-rounded is-light tooltip is-tooltip-bottom"
          data-tooltip="Reload"
          @click="reload"
        >
          <span class="icon">
            <i class="fas fa-sync-alt"></i>
          </span>
        </button>
      </div>
      <div id="button-container" class="column is-2 has-text-right">
        <button
          type="button"
          class="button is-success is-outlined is-light"
          :class="canExport ? '' : 'tooltip is-tooltip-bottom'"
          @click="exportToCSV"
          :data-tooltip="
            canExport
              ? ''
              : 'This is a payed feature. Please upgrade to gain access.'
          "
        >
          <span class="icon">
            <i class="fas" :class="canExport ? 'fa-file-csv' : 'fa-crown'"></i>
          </span>
          <span>Download CSV</span>
        </button>
      </div>
    </div>
    <!-- END Content header -->
    <!-- Content container -->
    <div class="columns">
      <div class="column full-width">
        <table
          id="leads-table"
          class="table is-striped is-fullwidth mb-4"
          ref="table"
        ></table>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from 'datatables.net-bm';
let tableInstance;
export default {
  name: 'Leads',
  components: {},
  data() {
    return {};
  },
  computed: {
    canExport() {
      let accessLevel = this.$store.getters['auth/getAccessLevel'];
      return (accessLevel && accessLevel.csvEmails?.value === true) || false;
    }
  },
  mounted() {
    tableInstance = new DataTable('#leads-table', {
      ajax: {
        url: this.$API.leads(),
        dataSrc: data => {
          return data.map(d => [d.email, d.name || 'N/A']);
        }
      },
      columns: [{ title: 'Email' }, { title: 'Name' }]
    });
  },
  methods: {
    reload() {
      tableInstance.ajax.reload();
    },
    exportToCSV() {
      if (!this.canExport) {
        return this.$router.push('/upgrade');
      }
      let csv = 'Email,Name\n';
      const data = tableInstance.data().map(d => `${d[0]},${d[1]}`);
      csv += data.join('\n');
      const dataUrl = `data:text/csv;charset=utf-8,${encodeURI(csv)}`;
      window.location.assign(dataUrl);
    }
  }
};
</script>
<style lang="scss">
label {
  .select {
    vertical-align: baseline;
  }
}
</style>
